export const intervention = {
  name_one: "intervention",
  name_other: "interventions",
  add: {
    label: "Add intervention",
  },
  addTemplate: "Add a template",
  batchEdit: {
    formError: {
      default: "An error occurred while updating interventions.",
      noItemUpdated: "No interventions have been modified.",
    },
    state: {
      optionTitle: "Interventions state",
      label: "State",
    },
    template: {
      optionTitle: "Interventions template",
      label: "Template",
    },
    scheduledDate: {
      optionTitle: "Interventions scheduled date",
      label: "Scheduled date",
    },
    users: {
      optionTitle: "Interventions users",
      label: "Users",
    },
  },
  batchEditSelect: {
    selected_one: "selected intervention.",
    selected_other: "selected interventions.",
  },
  batchTransition: {
    description_one: "Please apply a new status to the selected intervention.",
    description_other:
      "Please apply a new status to the different selected interventions.",
    info: "Discarted interventions cannot be modified.",
    formSuccess:
      "All interventions '{{initialState}}' have been changed to '{{newState}}' state.",
    formErrorGeneric:
      "An error occurred while editing interventions '{{initialState}}'.",
    formErrorItems:
      "The following interventions could not be modified: {{items}}.",
  },
  delete: {
    label: "Delete intervention",
  },
  details: {
    label: "Details",
  },
  dissociate: {
    title: "Dissociate the intervention",
    question: {
      project:
        "Dissociating the “{{intervention}}” intervention from the “{{project}}” project?",
    },
  },
  batchDissociate: {
    title: "Dissociate the interventions",
    question: {
      project:
        "Dissociating the selected interventions from the “{{project}}” project?",
    },
  },
  followUp: {
    button: {
      disabled:
        "The intervention must be completed and no follow-up exists to be able to follow up.",
    },
    checkbox: {
      label: "Follow up on completed observations.",
    },
    info: {
      pictures:
        "The photos will not be duplicated but will remain viewable in the original intervention.",
      recommendations:
        "Recommendations from observations will not be duplicated but linked to the new intervention.",
    },
  },
  duplicate: {
    checkbox: {
      label: "Duplicate intervention content",
      info: "The intervention will not be associated to any project. Recommended interventions will be linked and not duplicated.",
    },
  },
  form: {
    add: {
      label: "Add intervention",
    },
    creationDate: {
      label: "Creation date",
      tooltip:
        "Intervention created date to deduce intervention maximum due date and next study date",
    },
    associateInterventionWith: "Associate this intervention with",
    informations: "Intervention information",
    scheduledDate: {
      label: "Scheduled date",
    },
    description: {
      label: "Description",
    },
    edit: {
      label: "Edit intervention",
    },
    name: {
      label: "Name",
    },
    provider: {
      label: "Provider",
    },
    users: {
      label: "Users",
    },
    template: {
      label: "Template",
    },
    state: {
      label: "State",
    },
    cost: {
      label: "Cost",
      error: "The cost should be greater than $0",
    },
    costType: {
      label: "Cost's type",
      capex: "CAPEX",
      opex: "OPEX",
    },
    maxDaysDelay: {
      label: "Maximum delay in days",
      error: "1 day minimum",
    },
    subtype: {
      label: "Intervention subtype",
    },
    type: {
      label: "Intervention type",
    },
    progress: {
      label: "Progress",
    },
    templateSelectGroup: {
      local: "Asset's templates",
      global: "Other templates",
    },
    noTemplate: "No template",
  },
  recommendedBy: {
    label: "Recommended by",
  },
  launch: "Launch",
  map: "Map",
  modules: {
    label: "Reports and Modules",
  },
  noTemplate: "Intervention without template",
  observations: { label: "Observations" },
  plan: "Plan",
  recommendedInterventions: {
    label: "Recommended interventions",
    labelWithCount: "Recommended interventions ({{count}})",
  },
  running: "Running",
  seeChildrenInterventions: {
    label: "See children interventions",
  },
  seeParentIntervention: {
    label: "See parent intervention",
  },
  validation: {
    valid: "Validated by",
    needsValidation: "Needs validation",
    hasChanges: "Save changes before validating",
  },
  menu: {
    title: "Table of contents",
    loopOnChildrenTooltip: "Loop on children: {{sectionName}}",
    assetTypeTooltip: "Asset type: {{assetType}}",
  },
  sectionEmpty: {
    description: {
      form: "No form available.",
      tabs: "No additional information available.",
    },
    additionalInfoTitle: "Additional information",
    checkTemplate: "Check the template used.",
  },
};
